import { AccountSubType } from 'api/graphql-global-types';

export const isAthleteOrContentCreator = (accountType?: {
  value: AccountSubType;
}): boolean =>
  accountType?.value === AccountSubType.Athlete ||
  accountType?.value === AccountSubType.ContentCreator;
